module.exports = __webpack_public_path__ + "img/3_152.c4810e03.png";